import { render } from "./SectionCenterImageHtml.vue?vue&type=template&id=06810653&scoped=true"
import script from "./SectionCenterImageHtml.vue?vue&type=script&lang=js"
export * from "./SectionCenterImageHtml.vue?vue&type=script&lang=js"

import "./SectionCenterImageHtml.vue?vue&type=style&index=0&id=06810653&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06810653"]])

export default __exports__